import React from "react";
import EventWebinarInvitation from "./event-webinar-invitation";

type NewsletterCollectionProps = {
  response: {
    selected_layout: "event_webinar_invitation" | "thought_leadership";
    fields:[]
  };
  threadId:string,
  userId:string,
  onConfirm?: () => void; 
};

const NewsletterCollection: React.FC<NewsletterCollectionProps> = ({ response,threadId,userId , onConfirm }) => {

  return (
        <EventWebinarInvitation jsonData = {response} threadId={threadId} userId={userId} onConfirm={onConfirm}/>
  );
};

export default NewsletterCollection;
